import axios from "axios";
import {get, post} from "./api/axios";

const dashboardGet = (url, params) => get({
  service: "Dashboard",
  url: url,
  data: params,
  headers: {"Content-Type": "application/json; charset=UTF-8"}
});

const domainSecurityGet = (url, params) => get({
  service: "DomainSecurity",
  url: url,
  data: params,
  headers: {"Content-Type": "application/json; charset=UTF-8"}
});

const domainSecurityPost = (url, params) => post({
  service: "DomainSecurity",
  url: url,
  data: params,
  headers: {"Content-Type": "application/json; charset=UTF-8"}
});
const overviewGet = (url) => get({
  service: "OverView",
  url: url,
  headers: {"Content-Type": "application/json; charset=UTF-8"}
});
const NewYul = (url) => get({
  service: "NewYul",
  url: url,
  headers: {"Content-Type": "application/json; charset=UTF-8"}
});
const Asset = (url) => get({
  service: "Asset",
  url: url,
  headers: {"Content-Type": "application/json; charset=UTF-8"}
});
const SecPrac = (url) => get({
  service: "SecPrac",
  url: url,
  headers: {"Content-Type": "application/json; charset=UTF-8"}
});

const BugSearch = (url) => get({
  service: "BugSearch",
  url: url,
  headers: {"Content-Type": "application/json; charset=UTF-8"}
});

// 递归侧 PassiveDNS API
const passiveDnsGet = (url, params) => get({
  service: "PassiveDNS",
  url: url,
  data: params,
  headers: {"Content-Type": "application/json; charset=UTF-8"}
});

// MongoDB劫持案例API
const passiveDnsMongoGet = (url, params) => get({
  service: "PassiveDNSMongo",
  url: url,
  data: params,
  headers: {"Content-Type": "application/json; charset=UTF-8"}
});

// export const getAssetThreatStatisticsDict = params => dashboardGet("/get_asset_threat_statistics_dict", params);
export const getThreatScore = params => dashboardGet("/get_threat_score", params);

export const getModuleScore = () => overviewGet("/overall_score");
export const getMonitoringData = () => overviewGet("/measurement_scale");
export const getBasicSecurity = () => overviewGet("/vul_rank");
export const getInstitutionalFacilities = () => overviewGet("/ent_rank");
export const getBestPractices = () => overviewGet("/cn_us_cmp");
export const getSecurityBroadcast = () => overviewGet("/sec_news");
export const getVulnerabilityReporting = () => overviewGet("/disclosure");
//08 按钮组选择菜单
export const getButtonList = () => overviewGet("/map/type");
//08 3d视图打点
export const getVulnerableAssets = () => overviewGet("/map/vul_asset");
//08 3d/
export const getFlatCountry = () => overviewGet("/map/country");
export const getCountry = () => overviewGet("/map/country_3D");
//10 新型威胁
export const getNewThreats = () => NewYul("/info");
export const getVulnerabilityDescription = () => NewYul("/description");
export const getAffectedFacilities = () => NewYul("/ent");
export const getAffectedCountry = () => NewYul("/country");
//16 威胁评级
export const getThreatsLevel = () => NewYul("/level");
export const getVulnerableTrend = () => Asset("/trend");
export const getVulnerabilityNotification = () => Asset("/sit");
export const getAlarmEvents = () => Asset("/event");
//22 中国地图
export const getAssetCorrelationMap = () => Asset("/map/ent_geo");
export const getInstitutionalInformation = () => Asset("/map/ent_info");
export const getAlarmTiming = () => Asset("/map/event");
export const getMenuSorting = () => Asset("/map/menu");
export const getNationalDeploymentSituation = () => SecPrac("/cc_dep");
export const getDNSSEC = () => SecPrac("/01");
export const getDoT = () => SecPrac("/02");
export const getDoH = () => SecPrac("/03");
//29 世界地图
export const getWorldMap = () => SecPrac("/map");

export const getNumOfDifferentSource = () => BugSearch("/get_num_of_different_source");

// ==================== 域名安全监控新增API ====================

// 页面1：实体关联域名信息查询 API
// API 1-1-1: 获取已监控实体总数
export const getTotalEntity = () => domainSecurityGet("/total-entity");

// API 1-2-1: 获取实体基本信息
export const getEntityInfo = (params) => domainSecurityPost("/entity-info", params);

// API 1-2-2: 获取域名权威侧风险统计
export const getDomainAuthRisk = (params) => domainSecurityPost("/domain-auth-risk", params);

// API 1-2-3: 获取域名权威侧风险列表
export const getDomainAuthRiskList = (params) => domainSecurityPost("/domain-auth-risk-list", params);

// API 1-2-4: 获取域名权威侧风险详情
export const getDomainAuthRiskDetail = (params) => domainSecurityPost("/domain-auth-risk-detail", params);

// API 1-2-5: 查询域名归属机构
export const getDomainCompany = (domain) => domainSecurityGet("/domain-company", { domain });

// API 1-2-6: 批量查询域名归属机构
export const getDomainCompanyBatch = (domains) => post({
  service: "DomainSecurity",
  url: "/domain-company-batch",
  data: { domains },
  timeout: 10000,
  headers: { "Content-Type": "application/json; charset=UTF-8" }
});

// 授权依赖：批量查询域名所属榜单与排名
export const getDomainListMetadata = (domains) => post({
  service: "AuthDepMongo",
  url: "/domain-list-metadata",
  data: { domains },
  headers: { "Content-Type": "application/json; charset=UTF-8" }
});

// 页面2：权威侧域名配置与安全监控 API
// API 2-1-1: 获取组织机构权威侧风险监控数据
export const getOrgAuthRisk = () => domainSecurityGet("/org-auth-risk");

// API 2-1-2: 获取组织机构地理分布地图数据
export const getOrgAuthRiskMap = () => domainSecurityGet("/org-auth-risk-map");

// API 2-1-3: 获取组织机构权威侧风险统计
export const getOrgAuthRiskStatistic = () => domainSecurityGet("/org-auth-risk-statistic");

// API 2-1-4: 获取域名权威侧资源记录劫持事件列表
export const getDomainAuthHijackList = () => domainSecurityGet("/domain-auth-hijack-list");

// API 2-1-5: 获取域名权威侧风险地图详情（点击机构时）
export const getDomainAuthRiskMapDetail = (params) => domainSecurityGet("/domain-auth-risk-map", params);

// ==================== 页面3：递归域名解析监控 API ====================

// 格式化数字（添加千分位）
const formatNumber = (num) => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

// DNS响应码映射
const responseCodeMap = {
  0: "NOERROR",
  1: "FORMERR",
  2: "SERVFAIL",
  3: "NXDOMAIN",
  4: "NOTIMP",
  5: "REFUSED"
};

// API 3-1-1: 获取递归服务器查询量表格数据（真实API）
export const getRecQcountTab = async () => {
  try {
    // 获取当前小时数据
    const currentRes = await passiveDnsGet("/stats/hour_summary");

    // 获取历史数据用于计算均值
    const historyRes = await passiveDnsGet("/stats/month_daily_summary");

    // 计算历史均值
    let avgNewRows = "-";

    let avgSrcIp = "-";

    let avgQueryDomain = "-";

    if (historyRes && historyRes.length > 0) {
      const totalNewRows = historyRes.reduce((sum, item) => sum + (item.new_rows || 0), 0);
      const totalSrcIp = historyRes.reduce((sum, item) => sum + (item.unique_src_ip_count || 0), 0);
      const totalQueryDomain = historyRes.reduce((sum, item) => sum + (item.unique_query_domain_count || 0), 0);

      // 解析量和域名量除以24（历史数据是每天的，转换为每小时平均值）
      // 用户量不除以24（每天和每小时的用户数量差不多）
      avgNewRows = formatNumber(Math.round(totalNewRows / historyRes.length / 24));
      avgSrcIp = formatNumber(Math.round(totalSrcIp / historyRes.length));
      avgQueryDomain = formatNumber(Math.round(totalQueryDomain / historyRes.length / 24));
    }

    // 转换API返回的数据格式
    return {
      code: 200,
      data: {
        指标名: ["解析量", "用户量", "域名量"],
        本小时: [
          formatNumber(currentRes.new_rows || 0),
          formatNumber(currentRes.unique_src_ip_count || 0),
          formatNumber(currentRes.unique_query_domain_count || 0)
        ],
        历史均值: [avgNewRows, avgSrcIp, avgQueryDomain]
      }
    };
  } catch (error) {
    console.error("获取递归服务器查询量数据失败", error);
    return {
      code: 200,
      data: {
        指标名: [],
        本小时: [],
        历史均值: []
      }
    };
  }
};

// API 3-1-2: 获取递归服务器查询量折线图数据（真实API）
export const getRecQcountLine = async () => {
  try {
    const res = await passiveDnsGet("/stats/month_daily_summary");
    // 转换API返回的数据格式为ECharts需要的时间序列格式
    const 解析量 = res.map(item => [item.date, item.new_rows]);
    const 用户量 = res.map(item => [item.date, item.unique_src_ip_count]);
    const 域名量 = res.map(item => [item.date, item.unique_query_domain_count]);

    return {
      code: 200,
      data: {
        解析量,
        用户量,
        域名量
      }
    };
  } catch (error) {
    console.error("获取折线图数据失败", error);
    return {
      code: 200,
      data: {
        解析量: [],
        用户量: [],
        域名量: []
      }
    };
  }
};

// API 3-1-3: 获取递归服务器响应状态表格数据（真实API）
export const getRecRespstatusTab = async () => {
  try {
    const res = await passiveDnsGet("/stats/response_code_dist");
    // 计算总数
    const total = res.reduce((sum, item) => sum + (item.count || 0), 0);

    // 转换为百分比格式
    const responseData = res.map(item => ({
      code: responseCodeMap[item.response_code] || `CODE_${item.response_code}`,
      count: item.count || 0,
      percent: total > 0 ? ((item.count / total) * 100).toFixed(2) + "%" : "0%"
    }));

    return {
      code: 200,
      data: {
        响应码: responseData.map(d => d.code),
        本小时: responseData.map(d => d.percent),
        历史均值: responseData.map(() => "-")  // 真实API暂无历史均值
      }
    };
  } catch (error) {
    console.error("获取递归服务器响应状态数据失败", error);
    return {
      code: 200,
      data: {
        响应码: [],
        本小时: [],
        历史均值: []
      }
    };
  }
};

// API 3-1-4: 获取递归服务器响应状态饼图数据（真实API）
export const getRecRespstatusPie = async () => {
  try {
    const res = await passiveDnsGet("/stats/response_code_dist");
    // 计算总数
    const total = res.reduce((sum, item) => sum + (item.count || 0), 0);

    // 转换为百分比格式
    const responseData = res.map(item => ({
      code: responseCodeMap[item.response_code] || `CODE_${item.response_code}`,
      percent: total > 0 ? ((item.count / total) * 100).toFixed(2) : "0"
    }));

    return {
      code: 200,
      data: {
        响应码: responseData.map(d => d.code),
        本小时: responseData.map(d => d.percent)
      }
    };
  } catch (error) {
    console.error("获取饼图数据失败", error);
    return {
      code: 200,
      data: {
        响应码: [],
        本小时: []
      }
    };
  }
};

// API 3-1-8: 获取递归服务器响应码历史趋势数据（真实API）
export const getRecRespstatusHistory = async () => {
  try {
    const res = await passiveDnsGet("/stats/month_daily_response_code_dist");

    return {
      code: 200,
      data: res
    };
  } catch (error) {
    console.error("获取响应码历史数据失败", error);
    return {
      code: 200,
      data: []
    };
  }
};

// API 3-1-5: 获取递归服务器劫持事件统计数据（从MongoDB获取）
export const getRecHijkcountTab = async () => {
  try {
    const res = await passiveDnsMongoGet("/hijack-stats");

    return res;
  } catch (error) {
    console.error("获取劫持统计数据失败:", error);
    return {
      code: 200,
      data: {
        事件数: 0,
        涉及域名数: 0,
        涉及机构数: 0,
        涉及域名列表: []
      }
    };
  }
};

// API 3-1-6: 获取递归服务器劫持事件列表（从MongoDB获取）
export const getRecHijkinfoTab = async () => {
  try {
    const res = await passiveDnsMongoGet("/hijack-events");

    return res;
  } catch (error) {
    console.error("获取劫持事件列表失败:", error);
    return {
      code: 200,
      data: {
        告警时间: [],
        被劫持域名: [],
        "解析IP（恶意）": [],
        "解析IP（正常）": [],
        hijack_prob: [],
        影响机构: [],
        处置状态: []
      }
    };
  }
};

// API 3-1-7: 获取递归服务器查询量地图数据（从PassiveDNS真实接口获取）
export const getRecQcountMap = async () => {
  try {
    const res = await passiveDnsGet("/stats/ip_summary");

    if (Array.isArray(res)) {
      const provinceMap = {};

      res.forEach(item => {
        if (item.geo && item.geo.trim()) {
          provinceMap[item.geo] = (provinceMap[item.geo] || 0) + item.row_count;
        }
      });
      return { code: 200, data: provinceMap };
    }
    return { code: 200, data: {} };
  } catch (error) {
    console.error("获取地图数据失败:", error);
    return { code: 200, data: {} };
  }
};


// ==================== 页面4：恶意域名检测 API ====================
// 后端 202.112.47.187:13691，路径 /api/malicious/*，X-API-Key 由代理层注入
// 所有接口接受 range_days 参数（7/30/90）
const maliciousGet = (url, params) => get({
  service: "Malicious",
  url: url,
  data: params,
  headers: {"Content-Type": "application/json; charset=UTF-8"}
});

// API 4-1: 省份源 IP 统计（访问恶意域名的 IP 省份分布）
export const getMaliciousProvinceIps = (params) => maliciousGet("/province-ips", params);

// API 4-2: /16 网段恶意域名数量统计
export const getMaliciousCidr16DomainCounts = (params) => maliciousGet("/cidr16-domain-counts", params);

// API 4-3: 恶意域名解析 IP 拓扑
export const getMaliciousDomainIpTopology = (params) => maliciousGet("/domain-ip-topology", params);

// API 4-4: 恶意域名类型统计
export const getMaliciousTypeCounts = (params) => maliciousGet("/type-counts", params);

// API 4-5: 每日趋势统计（dnsspike + GNN）
export const getMaliciousDailyTrend = (params) => maliciousGet("/daily-trend", params);

// API 4-6: 恶意事件明细（分页）
export const getMaliciousEvents = (params) => maliciousGet("/events", params);

// ==================== 页面5：DNS解析器演化追踪 API ====================// 后端 202.112.51.102:7788，路径 /api/dns_resolver_dashboard/*.json
// 上游是离线聚合产出的静态 JSON，无查询参数，筛选/分页全部在前端完成
const resolverGet = (url) => get({
  service: "ResolverDash",
  url: url,
  headers: {"Content-Type": "application/json; charset=UTF-8"}
});

// ---- 基本态势 ----
// API 5-1: 概览（扫描轮数 / 累计解析器 / 覆盖组织 / 最近转发器数量）
export const getResolverOverview = () => resolverGet("/overview.json");

// API 5-2: 历史扫描解析器数量变化
export const getResolverTrend = () => resolverGet("/resolver_trend.json");

// API 5-3: Top 5 国家数量分布
export const getResolverTopCountries = () => resolverGet("/top_countries.json");

// API 5-4: Top 5 ASN 数量分布
export const getResolverTopAsns = () => resolverGet("/top_asns.json");

// API 5-5: IP 与 /24 网络换血率波动
export const getResolverChurn = () => resolverGet("/churn.json");

// API 5-6: IP 稳定分类
export const getResolverIpStability = () => resolverGet("/ip_stability.json");

// API 5-7: /24 网络稳定分类
export const getResolverNet24Stability = () => resolverGet("/net24_stability.json");

// API 5-8: 国家级异动时间线
export const getResolverCountryTimeline = () => resolverGet("/country_anomaly_timeline.json");

// API 5-9: ASN 级异常时间线
export const getResolverAsnTimeline = () => resolverGet("/asn_anomaly_timeline.json");

// API 5-10: 异动事件全量列表（约 6.6MB，前端筛选）
export const getResolverAnomalyEvents = () => resolverGet("/anomaly_events.json");

// API 5-11: 国家查询画像（约 200KB，按需加载）
export const getResolverCountryProfiles = () => resolverGet("/country_profiles.json");

// API 5-12: ASN 查询画像（约 23MB，仅在查询 AS 号时按需加载）
export const getResolverAsnProfiles = () => resolverGet("/asn_profiles.json");

// ---- 风险态势 ----
// API 5-13: 集中单点依赖地图
export const getResolverRiskSingleFailureMap = () => resolverGet("/risk_single_failure_map.json");

// API 5-14: 全量单点上游影响规模分布
export const getResolverRiskImpactDistribution = () => resolverGet("/risk_upstream_impact_distribution.json");

// API 5-15: 中国解析器解析流量出境地图
export const getResolverRiskChinaEgressMap = () => resolverGet("/risk_china_egress_map.json");

// API 5-16: 国内下游 DNS 解析器与上游解析器对比分析
export const getResolverRiskJurisdiction = () => resolverGet("/risk_jurisdiction_distribution.json");

// API 5-17: 软件类型分布（含 country/asn/org 三个维度的过滤视图）
export const getResolverRiskSoftwareType = () => resolverGet("/risk_software_type.json");

// API 5-18: 软件受影响 IP 数
export const getResolverRiskSoftwareImpact = () => resolverGet("/risk_software_impact.json");

// API 5-19: CVE Top
export const getResolverRiskCveTop = () => resolverGet("/risk_cve_top.json");

// API 5-20: 软件 × CVE 热力矩阵
export const getResolverRiskSoftwareCveMatrix = () => resolverGet("/risk_software_cve_matrix.json");

// API 5-21: 风险等级分布
export const getResolverRiskLevelDistribution = () => resolverGet("/risk_level_distribution.json");

// API 5-22: 老版本占比
export const getResolverRiskLegacyVersionShare = () => resolverGet("/risk_legacy_version_share.json");

// API 5-23: 风险查询明细（约 21MB / 12 万行，columns + rows 二维数组，前端筛选分页）
export const getResolverRiskQueryResults = () => resolverGet("/risk_query_results.json");

// ==================== 机构解析链依赖查询 ====================
// 机构索引约 4.3MB / 10115 个 ASN，含 aliases 与 search_text，供前端做自然语言机构名匹配
export const getOrgDependencyIndex = () => resolverGet("/org_dependency_index.json");

// 单个 ASN 的上下游拓扑明细（3KB ~ 1.4MB，按 ASN 按需加载）
export const getOrgDependencyDetail = (asn) => resolverGet(`/org_dependency_details/asn_${asn}.json`);

// PassiveDNS flint 正向查询（返回 NDJSON，需特殊处理）
export const queryPassiveDnsFlint = async (domain, queryType = "A") => {
  const res = await axios({
    method: "post",
    url: "/passivedns/flint",
    data: { query_domain: domain, query_type: queryType },
    headers: { "Content-Type": "application/json" },
    responseType: "text",
    transformResponse: [data => data],  // 禁止 axios 0.19 自动 JSON.parse
    timeout: 30000
  });
  const raw = res.data || "";
  const lines = raw.trim().split("\n").filter(l => l.trim());

  return lines.map(l => {
    try {
      return JSON.parse(l);
    } catch {
      return null;
    }
  }).filter(Boolean);
};




// ==================== 页面4-2：黑帽SEO通报 API ====================
// 数据源是服务端本地离线索引（scripts/build-abuse-index.js 产出），不走上游接口
// 接口无 date 维度，不需要 range_days；筛选/分页全部在服务端完成
const abuseSeoGet = (url, params) => get({
  service: "AbuseSeo",
  url: url,
  data: params,
  headers: {"Content-Type": "application/json; charset=UTF-8"}
});

// API 4-7: 黑帽SEO通报明细（服务端分页 + 维度筛选 + 域名关键词）
export const getAbuseSeoEvents = (params) => abuseSeoGet("/seo-events", params);

// API 4-8: 黑帽SEO维度取值与计数（供筛选下拉渲染）
export const getAbuseSeoStats = () => abuseSeoGet("/seo-stats");
